import { axios } from '@/utils/request'
import Vue from 'vue'
const api = {
  getFansList: '/5cb07ea5d4413',
  getDieFansList: '/5f65759b32eba',
  getGroupList: '/5cb15854a5f1d',
  updateFensInfo: '/5cb1552b91bca',
  getFansInfo: '/5cb96c85a2f29',
  updateFansTags: '/5cb97ddfcc7d1',
  updateFansRemark: '/6180a3f2af921',
  getBlackList: '/5d521ed7968c5',
  addBlackList: '/5cbacf8bad18e',
  createDieFans: '/5f656f6c90e0e',
  deleteBlackUser: '/5d8dce9f348ac',
  getWxUserList: '/5cc4085b2aca3',
  getFansByWxid: '/5d3c3850d0e55',
  updateFansGroup: '/5e968266c15ce',
  delGroupList: '/5f0be4f91cc3f',
  getMemberId: '/5fbe07bf7884f',
  resetZfbInfo: '/60ef9f7977290',
  getNewfansList: '/62c7e6f31542b',
  selectList:'62f4d8c89ad00',
  addInactive: '6386f20b5b6b6', // 添加僵尸粉
  delFans: '/646db687e4300', // 删除会员
  filterFansList: '/6475a99301fa9', // 过滤会员列表
  filterFansData: '/6475c6da38d0d',
}

export default {

  // 添加僵尸粉
  addInactive(parameter){
    return axios({
      url: api.addInactive,
      method: 'post',
      data: parameter
    })
  },

  // 获取用户wxid
  getMemberId: parameter => {
    const params = Object.assign(parameter, {
      uid: parameter.uid,
      sub_id: parameter.sub_id,
    })
    return axios({
      url: api.getMemberId,
      method: 'get',
      params: params,
    }).then(res => {
      return res
    })
  },
  // 删除所在群组
  delGroupList: parameter => {
    const params = Object.assign(parameter, {
      uid: parameter.uid,
      sub_id: parameter.sub_id,
    })
    return axios({
      url: api.delGroupList,
      method: 'get',
      params: params,
    }).then(res => {
      return res
    })
  },
  // 重置支付宝信息
  resetZfbInfo: parameter => {
    return axios({
      url: api.resetZfbInfo,
      method: 'post',
      data: parameter,
    })
  },
  // 获取死粉丝列表
  getDieFansList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getDieFansList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 保存检测配置
  createDieFans: parameter => {
    return axios({
      url: api.createDieFans,
      method: 'post',
      data: parameter,
    })
  },
  // 获取粉丝列表
  getFansList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getFansList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
        code:res.code,
        msg:res.msg
      }
    })
  },
	selectList: parameter => {
    // console.log("筛选后一键加入群发列表，传给接口的参数=",parameter)
	  const params = Object.assign(parameter, {
	    page: parameter.pageNo || 1,
	    size: parameter.pageSize || 100000,
      //robot_id:parameter.sub_id
	  })
	  return axios({
	    url: api.selectList,
	    method: 'get',
	    params: params,
	  }).then(res => {
      // console.log("筛选后一键加入群发列表,接口返回值=",res);
	    return {
	      data: res.data.list || [], 
	      pageNo: parameter.pageNo,
	      pageSize: parameter.pageSize,
	      totalCount: res.data.count,
	      code:res.code,
	      msg:res.msg
	    }
	  })
	},
  // 获取微信好友列表
  getWxUserList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getWxUserList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 获取会员分组列表
  getGroupList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 40,
    })
    return axios({
      url: api.getGroupList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 通过嵌入窗口获取会员分组列表
  getIframeGroupList: (parameter, token) => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 40,
    })
    return axios({
      url: api.getGroupList,
      method: 'get',
      headers: { 'user-token': token },
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 修改会员信息
  updateFensInfo: ({ uid, sub_id, trjid, balance, integral, usertype, order_sixbit }) => {
    const parameter = {
      uid,
      sub_id,
      trjid,
      integral,
      balance,
      usertype,
      order_sixbit,
    }
    return axios({
      url: api.updateFensInfo,
      method: 'post',
      data: parameter,
    })
  },
  // 通过嵌入窗口修改会员信息
  iframeUpdateFensInfo: ({ uid, sub_id, trjid, balance, integral, usertype, order_sixbit, token }) => {
    const GoogleAuthMark = Vue.ls.get('GoogleAuthMark')
    const parameter = {
      uid,
      sub_id,
      trjid,
      integral,
      balance,
      usertype,
      order_sixbit,
    }
    return axios({
      url: api.updateFensInfo,
      method: 'post',
      headers: { 
        'user-token': token,
        'google-auth-mark':GoogleAuthMark
      },
      data: parameter,
    })
  },
  // 获取会员详细信息
  getFansInfo: ({ sub_id, uid }) => {
    const parameter = {
      sub_id,
      member_id: uid,
    }
    return axios({
      url: api.getFansInfo,
      method: 'get',
      params: parameter,
    })
  },
  // 通过嵌入窗口获取会员详细信息
  getIframeFansInfo: ({ sub_id, uid, token }) => {
    const parameter = {
      sub_id,
      member_id: uid,
    }
    return axios({
      url: api.getFansInfo,
      method: 'get',
      headers: { 'user-token': token },
      params: parameter,
    })
  },
  // 更新会员标签
  updateFansTags: ({ sub_id, uid, tags }) => {
    const parameter = {
      sub_id,
      member_id: uid,
      tag: tags,
    }
    return axios({
      url: api.updateFansTags,
      method: 'post',
      data: parameter,
    })
  },
  // 通过嵌入窗口修改标签
  iframeUpdateFansTags: ({ sub_id, uid, tags, token }) => {
    
    // config.headers['google-auth-mark'] = GoogleAuthMark
    const parameter = {
      sub_id,
      member_id: uid,
      tag: tags,
    }
    return axios({
      url: api.updateFansTags,
      method: 'post',
      headers: { 
        'user-token': token,
      },
      data: parameter,
    })
  },
  // 更新会员自定备注
  updateFansRemark: ({ sub_id, uid, remark }) => {
    const parameter = {
      sub_id,
      member_id: uid,
      customer_remark: remark,
    }
    return axios({
      url: api.updateFansRemark,
      method: 'post',
      data: parameter,
    })
  },
  // 通过嵌入窗口更新会员自定备注
  iframeUpdateFansRemark: ({ sub_id, uid, remark, token }) => {
    const parameter = {
      sub_id,
      member_id: uid,
      customer_remark: remark,
    }
    return axios({
      url: api.updateFansRemark,
      method: 'post',
      headers: { 'user-token': token },
      data: parameter,
    })
  },
  // 更新会员分组
  updateFansGroup: parameter => {
    return axios({
      url: api.updateFansGroup,
      method: 'post',
      data: parameter,
    })
  },
  // 获取全网黑名单列表
  getBlackList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20,
    })
    return axios({
      url: api.getBlackList,
      method: 'get',
      params: params,
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },
  // 上传黑名单
  addBlackList: ({ sub_id, wx_id, snapshot, type, remark }) => {
    const parameter = {
      sub_id,
      wx_id,
      snapshot,
      type,
      remark,
    }
    return axios({
      url: api.addBlackList,
      method: 'post',
      data: parameter,
    })
  },
  // 移除黑名单用户
  deleteBlackUser: ({ ids }) => {
    const parameter = { white_list: ids }
    return axios({
      url: api.deleteBlackUser,
      method: 'post',
      data: parameter,
    })
  },
  // 根据机器人ID和微信ID查询会员信息
  getFansByWxid: ({ sub_id, wxid }) => {
    const parameter = {
      sub_id: sub_id,
      wx_id: wxid,
    }
    return axios({
      url: api.getFansByWxid,
      method: 'get',
      params: parameter,
    })
  },
  // 获取新粉丝列表
  getNewfansList:(parameter)=>{
    const params = Object.assign(parameter,{
      page:parameter.pageNo||1,
      size:parameter.pageSize||20
    })
    return axios({
      url:api.getNewfansList,
      method:'get',
      params
    }).then(res=>{
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
      }
    })
  },

  // 删除会员
  delFans: parameter => {
    return axios({
      url: api.delFans,
      method: 'get',
      params: parameter,
    })
  },

  // 过滤会员列表
  filterFansList: parameter => {
    return axios({
      url: api.filterFansList,
      method: 'post',
      data: parameter
    })
  },

  // 将过滤好的数据发给后端
  filterFansData: parameter => {
    return axios({
      url: api.filterFansData,
      method: 'post',
      data: parameter
    })
  },

}
